// What the board shows of the hold on it, without React: while an owner
// (a puzzle) holds the board's constraints, the board wears the accent frame,
// and while the next move is the owner's to judge, the side to move reads
// "your move" in the accent, so the puzzle is unmistakable. Pure; the board
// in `index.tsx` reads the registry and the review and draws this.
import type { Color, Fen } from '@chess/api-model';
import type { NextMoveMode } from '@chess/api-constraints';
import { sideToMove } from '@chess/api-review';

export interface BoardHold {
  /** The accent frame around the board. */
  framed: boolean;
  /** The side whose line reads "your move", if any. */
  yourMove?: Color;
}

/**
 * The hold for a state: `held` when the scope has an owner, `nextMove` the
 * combined Next move constraint, `fen` the position on the board and
 * `browsing` whether the reader is looking back (nothing is played then).
 */
export function boardHold(held: boolean, nextMove: NextMoveMode, fen: Fen | undefined, browsing: boolean): BoardHold {
  if (!held) return { framed: false };
  const yourMove = nextMove === 'judged' && fen && !browsing ? sideToMove(fen) : undefined;
  return yourMove ? { framed: true, yourMove } : { framed: true };
}
